<app-menu [menuModuleEnum]='menuModuleEnum' [menuFunctionalityEnum]='menuFunctionalityEnum'></app-menu>

<div class="container-body">
    <h1>Origens</h1>
    <div class="white-body">
        <a mat-button class="btn-primary add-user" routerLink="/datamesh/data-set/register"><mat-icon
                aria-hidden="false" aria-label="Plus">add</mat-icon> Nova origem de dados</a>
        <div class="filters">
            <div class="row">
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix class="my-icon">search</mat-icon>
                        <mat-label>Search</mat-label>
                        <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText"
                            (keyup)="onKeySearch($event)">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="card-list" *ngIf="listDataset != null">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4" *ngFor="let item of listDataset">
                    <div class="card-item">
                        <div class="infos">
                            <span class="primary">{{item.dataSetName}}</span>
                            <span class="secundary">{{item.datetimeInclusion | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
                        </div>
                        <div class="actions">
                            <a><mat-icon aria-hidden="false" aria-label="Edit"
                                    [routerLink]="['/datamesh/data-set/register', {idDataSet: item.idDataSet}]">edit</mat-icon>
                            </a>
                            <a><mat-icon aria-hidden="false" aria-label="Delete"
                                    (click)="deleteDataSet(item.idDataSet)">delete_forever</mat-icon> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-empty-list *ngIf="listDataset != undefined && listDataset.length == 0"></app-empty-list>
        <app-loading-list *ngIf="isLoading"></app-loading-list>
    </div>